import {OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CrudService} from '../_services';
import {FormGroup} from '@angular/forms';
import {CrudSaveComponent} from '../_directives';
import {BasePlan} from "../_models";
import {takeUntil} from "rxjs/operators";

export abstract class PlanFormAbstractComponent extends CrudSaveComponent implements OnInit {
  plan: BasePlan;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected planService: CrudService,
    protected alertService: AlertService
  ) {
    super(router, location, route, planService, alertService);
  }

  ngOnInit() {
    this.form = this.buildForm();
    super.ngOnInit();

    this.data$.pipe(takeUntil(this.destroy$)).subscribe((plan: BasePlan) => {
      if (plan) {
        this.plan = plan;
        this.form.patchValue(this.getFormValues(plan));
      }
    });
  }

  protected getFormValues(plan: BasePlan): BasePlan {
    return plan;
  }

  protected abstract buildForm(): FormGroup;
}
